<template>
  <div>
    <UIProgressCircular v-show="!dataLoaded"/>

    <div
      v-show="dataLoaded"
      class="mt-4"
    >
      <v-row class="my-0">
        <v-col
          cols="12"
          class="py-0"
        >
          <v-card class="pa-4 base-card z-10 d-flex justify-space-between align-center">
            <h3>Мероприятия</h3>

            <div class="d-flex">
              <ButtonOutlineSmall
                v-if="isAdmin"
                title="Добавить"
                icon="plus"
                @click="dialog = true"
              />

              <ButtonIconSmall
                v-if="(!isXs && !isHorizontalLabel) || (isXs && isShowTable)"
                class="ml-2"
                :icon="isShowTable ? 'grid-icon' : 'menu-icon'"
                @click="switchShowTable"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row
        v-if="isShowTable"
        class="my-0 mt-4"
      >
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card
            ref="mainCard"
            class="base-card pb-4 px-4"
          >
            <v-data-table
              ref="table"
              v-scroll.self="tableScroll"
              class="elevation-0 events-table"
              :class="isXs ? 'mobile-table' : 'base-table'"
              :loading="tableLoading"
              :headers="tableHeaders"
              :items="nonHiddenEventList"
              :items-per-page="-1"
              loading-text="Загрузка"
              no-data-text="Нет данных"
              no-results-text="Не найдено"
              hide-default-footer
              fixed-header
            >
              <template #[`item.isHidden`]="{ item }">
                {{ getBooleanTextValue(item.isHidden) }}
              </template>

              <template #[`item.isClosed`]="{ item }">
                {{ getBooleanTextValue(item.isClosed) }}
              </template>

              <template #[`item.actions`]="{ item }">
                <nav style="display: flex;  gap: 8px;">
                  <v-icon
                    v-if="item.status.id === 2"
                    class="uikit-icon pen show-btn"
                    title="Зарегистрироваться"
                    @click="signUp(item)"
                  />
                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon office-building-marker size-20"
                    title="Локации"
                    @click.stop="goToLocations(item)"
                  />
                  <v-icon
                    v-if="!isUser"
                    class="uikit-icon calendar show-btn size-20"
                    title="События"
                    @click="goToEventParts(item)"
                  />
                  <v-icon
                    v-if="isOperatorRoles"
                    class="uikit-icon show-btn file-document-edit-outline size-20"
                    title="Настройка и формы"
                    @click="goToForms(item)"
                  />
                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon trash remove-btn size-20"
                    title="Удалить"
                    @click="remove(item)"
                  />
                </nav>
              </template>

              <template slot="no-data">
                <div>Таблица пуста</div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <v-list
        v-else
        ref="list"
        class="px-4 pt-0 transparent overflow-auto"
      >
        <v-row class="my-0 mt-4">
          <v-col
            v-for="(item) of nonHiddenEventList"
            :key="item.id"
            cols="12"
            sm="6"
            lg="4"
            xl="3"
            class="pt-0 d-flex"
            :class="$vuetify.breakpoint.xs ? 'px-0' : ''"
          >
            <v-card
              class="base-card pb-4 px-4 w-full d-flex flex-column justify-space-between"
              :ripple="false"
            >
              <div>
                <v-card-title
                  class="d-flex justify-space-between card-title-link-text"
                  style="word-break: break-word"
                >
                  <span>{{ item.name }}</span>
                </v-card-title>
                <v-card-text>
                  <div><strong>Время начала:</strong> {{ item.dateTimeFromText }}</div>
                  <div class="mt-2">
                    <strong>Время окончания:</strong> {{ item.dateTimeToText }}
                  </div>

                  <div class="mt-2">
                    <strong>Адрес:</strong> {{ item.address }}
                  </div>
                  <div
                    v-if="item.contactData"
                    class="mt-2"
                  >
                    <strong>Контактные данные:</strong> {{ item.contactData }}
                  </div>
                  <div class="mt-2">
                    <strong>Статус:</strong> {{ item.status && item.status.name }}
                  </div>
                </v-card-text>
              </div>

              <v-card-actions class="d-flex flex-column">
                <nav
                  class="mt-2 mb-2 w-full"
                  style="display: flex; justify-content: end; gap: 16px"
                >
                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon office-building-marker primary-h size-24"
                    title="Локации"
                    @click.stop="goToLocations(item)"
                  />
                  <v-icon
                    v-if="isOperatorRoles"
                    class="uikit-icon calendar-clock primary-h size-24"
                    title="События"
                    @click="goToEventParts(item)"
                  />
                  <v-icon
                    v-if="isOperatorRoles"
                    class="uikit-icon file-document-edit-outline primary-h size-24"
                    title="Настройка и формы"
                    @click.stop="goToForms(item)"
                  />
                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon trash error-h remove-btn size-24"
                    title="Удалить"
                    @click.stop="remove(item)"
                  />
                </nav>

                <v-btn
                  color="primary"
                  outlined
                  class="d-flex align-center w-full"
                  :class="$vuetify.breakpoint.xs ? '' : 'px-4'"
                  :loading="signUpLoadingId === item.id"
                  :disabled="item.status.id === 1"
                  @click.stop="signUp(item)"
                >
                  <v-icon
                    class="uikit-icon pen"
                    :class="item.status.id === 1 ? 'greylighten1' : 'primary'"
                  />
                  <span class="pl-3 btn-text">Зарегистрироваться</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-list>
    </div>

    <EventDialog
      :dialog="dialog"
      :save-btn-loading="saveBtnLoading"
      :selected-item="selectedItem"
      :is-show-mode="isShowMode"
      @saveEvent="saveEvent"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeEvent"
      @closeConfirmModal="closeConfirmDialog"
    />
  </div>
</template>

<script>
import { EventList } from '@/models'
import {
  eventApi,
  formTemplateApi,
} from '@/api'
import {
  cloneDeep,
  debounce,
} from 'lodash'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import EventDialog from '@/components/Spm/Events/EventsPage/dialogs/EventDialog'
import UIProgressCircular from '@/ui/progress/UIProgressCircular'
import {
  mapActions,
  mapGetters,
} from 'vuex'
import ButtonOutlineSmall from '@/featureSlicedDesign/shared/ui/ButtonOutlineSmall'
import ButtonIconSmall from '@/featureSlicedDesign/shared/ui/ButtonIconSmall'
import { getBooleanTextValue } from '../../../scripts/checkbox'

export default {
  name: 'EventsPage',

  metaInfo: { title: 'Мероприятия' },

  components: {
    ButtonIconSmall,
    ButtonOutlineSmall,
    UIProgressCircular,
    EventDialog,
    ConfirmDialog,
  },

  async created() {
    await this.getEventList()
    this.dataLoaded = true
  },

  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setTableHeight)
  },

  data: () => ({
    eventList: new EventList(),

    selectedItem: null,

    confirmDialog: false,
    dialog: false,

    isShowMode: false,

    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,

    signUpLoadingId: null,
  }),

  computed: {
    ...mapGetters('breakpoint', ['isXs', 'isHorizontalLabel']),
    ...mapGetters('settings', ['isShowTable', 'isShowFullNews']),
    ...mapGetters('user', ['isOperatorRoles', 'isAdmin', 'isUser']),

    tableHeaders() {
      return [
        { text: 'id', value: 'id', sortable: false, align: 'start' },
        { text: 'Название', value: 'name', sortable: false, align: 'start' },
        { text: 'Время начала', value: 'dateTimeFromText', sortable: false, align: 'start', width: '160px' },
        { text: 'Время окончания', value: 'dateTimeToText', sortable: false, align: 'start', width: '160px' },
        { text: 'Адрес', value: 'address', sortable: false, align: 'start' },
        { text: 'Контактные данные', value: 'contactData', sortable: false, align: 'start' },
        // { text: 'Ссылка', value: 'siteLink', sortable: false, align: 'start' },
        { text: 'Статус', value: 'status.name', sortable: false, align: 'start' },
        { text: 'Скрыто', value: 'isHidden', sortable: false, align: 'center' },
        { text: 'Закрыта регистрация', value: 'isClosed', sortable: false, align: 'center' },
        {
          text: 'Действия',
          value: 'actions',
          sortable: false,
          align: 'end',
          width: this?.isOperatorRoles ? '180px' : '80px'
        },
      ]
    },

    nonHiddenEventList() {
      return this.isOperatorRoles ? this.eventList.list : this.eventList.list.filter((event) => !event.isHidden)
    },
  },

  methods: {
    getBooleanTextValue,
    ...mapActions('settings', ['setIsShowTable']),

    switchShowTable() {
      this.setIsShowTable(!this.isShowTable)
      this.setTableHeight()
    },

    showSearch() {
      this.isShowSearch = !this.isShowSearch
      this.isShowFilter = false
      this.setTableHeight()
    },

    showFilter() {
      this.isShowFilter = !this.isShowFilter
      this.isShowSearch = false
      this.setTableHeight()
    },

    async getEventList() {
      try {
        this.tableLoading = true

        const content = await eventApi.getCatalog()
        this.eventList = new EventList()

        content.length && content.forEach((obj) => this.eventList.add(obj.event))
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения мероприятий')
      } finally {
        this.tableLoading = false
      }
    },

    goToForms(item) {
      this.$router.push(`/spm/events/${item.id}/formTemplatePage`)
    },

    goToLocations(item) {
      this.$router.push(`/spm/events/${item.id}/locations`)
    },

    goToEventParts(item) {
      !this.isUser && this.$router.push(`/spm/events/${item.id}/eventParts`)
    },

    async signUp(item) {
      try {
        this.signUpLoadingId = item.id

        if (item.isClosed) {
          this.$toastr('warning', 'Регистрационная форма еще не создана или закончены сроки ее подачи')
          return
        }

        const list = await formTemplateApi.findAllByEventId(item.id)
        const regForm = list.find((el) => el.isMainForRegistration)
        if (regForm) await this.$router.push(`/spm/form/${regForm.id}/personalRegistration`)
        else this.$toastr('warning', 'Регистрационная форма еще не создана или закончены сроки ее подачи')
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения регистрационной формы')
      } finally {
        this.signUpLoadingId = null
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async saveEvent(body) {
      try {
        this.saveBtnLoading = true
        const data = body.id ? await eventApi.update(body) : await eventApi.create(body)

        body.id ? this.eventList.update(data) : this.eventList.add(data)
        this.$toastr('success', '', 'Мероприятие успешно сохранено')
        this.closeDialog()

        !body.id && this.goToForms(data)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeEvent() {
      try {
        this.removeLoading = true
        await eventApi.remove(this.selectedItem.id)
        this.eventList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },

    setTableHeight() {
      this.$nextTick(() => {
        if (this.$refs?.table) {
          const footerHeight = 67
          const topHeight = this.$refs.table.$el.getBoundingClientRect().top

          this.$refs.table.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }

        if (this.$refs?.list) {
          const footerHeight = 67
          const topHeight = this.$refs.list.$el.getBoundingClientRect().top

          this.$refs.list.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }
      })
    },

    tableScroll() {
      // const el = event.target
      // if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
      // }
    },

    setFilters: debounce(async function debounceSetFilters(filters) {
      this.filters = cloneDeep(filters)
    }, 500),

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },
  },

  watch: {
    dataLoaded() {
      if (this.isXs || this.isHorizontalLabel) {
        this.setIsShowTable(false)
      }
      this.setTableHeight()
    },

    filters: {
      deep: true,
      async handler() {
        this.pageNumber = 0
        this.lastPage = false
        this.total = 0
        await this.getEventList()
      },
    },

    isXs: {
      handler() {
        if (this.isXs || this.isHorizontalLabel) {
          this.setIsShowTable(false)
          this.setTableHeight()
        }
      },
    },

    isShowFullNews() {
      this.setTableHeight()
    },
  },
}
</script>

<style lang="scss">
.events-table {
  tr {
    th:last-child,
    td:last-child {
      position: sticky;
      right: 0;
      background-color: #f5f9fd;
      border-left: 2px solid var(--v-lightBlue-base) !important;
    }
  }
}
</style>
